import React from "react";

import Script from "dangerous-html/react";

const AboutSection: React.FC = () => (
  <section className="about-wrapper" id="about">
    <div className="about-content-container">
      <div className="about-header">
        <h2 className="section-title">Professional Journey</h2>
        <p className="section-subtitle">
          18+ years designing world-class cloud, enterprise, and Generative AI
          solutions across India, UK, and global clients.
        </p>
      </div>

      <div className="about-summary">
        <h3 className="about-summary-title">What I do as an Architect</h3>
        <ul className="about-summary-list">
          <li>
            Design cloud-native architectures (AWS, Kubernetes, Kafka) for
            large-scale platforms.
          </li>
          <li>
            Modernize legacy systems using microservices, strangler-fig, and
            event-driven patterns.
          </li>
          <li>
            Lead cross-functional teams from discovery to production rollout and
            observability.
          </li>
        </ul>
      </div>

      <div className="about-timeline">
        <div className="about-timeline-line"></div>

        {/* IRIS SOFTWARE TECHNOLOGIES, Architect (Sep 2023 – Oct 2025) */}
        <div className="about-timeline-item">
          <div className="about-timeline-marker"></div>
          <div className="about-timeline-content">
            <div className="about-timeline-year">
              <span>2023 – 2025</span>
            </div>
            <h3 className="about-timeline-title">
              Associate Manager - Technology (Architect) – Iris Software
              Technologies
            </h3>
            <ul>
              <li>
                Architected AWS-native, serverless student data platform—10M+
                records processed daily
              </li>
              <li>
                Led development of GenAI analytics/reporting (AWS Bedrock,
                Python FastAPI, Angular)
              </li>
              <li>
                Guided a team of 20+, increasing project delivery efficiency by
                25%
              </li>
              <li>
                Designed high-availability, low-latency architectures using AWS
                Route53, CloudFront, ALB, ECS, DynamoDB
              </li>
              <li>
                Implemented distributed validation—95% data accuracy, 80% less
                manual effort
              </li>
              <li>
                Worked with international stakeholders for requirements,
                sign-off, and reviews
              </li>
            </ul>
          </div>
        </div>
        {/* SUCCESS NUMBERS LLC, Lead SDE/Architect (Nov 2022 – May 2023) */}
        <div className="about-timeline-item">
          <div className="about-timeline-marker"></div>
          <div className="about-timeline-content">
            <div className="about-timeline-year">
              <span>2022 – 2023</span>
            </div>
            <h3 className="about-timeline-title">
              Lead SDE / API-Architect – Success Numbers LLC
            </h3>
            <ul>
              <li>
                Led microservices for checkout & mPOS across 4000+ retail stores
              </li>
              <li>
                Implemented REST APIs (Spring Boot, Spring Cloud Gateway) and
                event-driven inventory with Kafka
              </li>
              <li>
                Established scalable, secure patterns; mentored 10-member team
              </li>
              <li>
                Advanced monitoring (OpenTelemetry, Elastic, Kibana) and
                security (OAuth 2.0, JWT, SSL/TLS)
              </li>
            </ul>
          </div>
        </div>
        {/* INTERNATIONAL NON-PROFIT, Architect (2014–2022) */}
        <div className="about-timeline-item">
          <div className="about-timeline-marker"></div>
          <div className="about-timeline-content">
            <div className="about-timeline-year">
              <span>2014 – 2022</span>
            </div>
            <h3 className="about-timeline-title">
              Architect – International Non-Profit (Noida/Ranchi)
            </h3>
            <ul>
              <li>
                Architected and shipped cloud ERP for 100+ institutions (Java,
                Spring Boot, AWS, Docker)
              </li>
              <li>
                Drove DevOps, observability, and microservices—integrated
                Cognito, New Relic, containerization
              </li>
              <li>
                Converted requirements to Jira stories and delivered agile
                sprints
              </li>
              <li>Managed/mentored 8+ developers</li>
            </ul>
          </div>
        </div>
        {/* EARLY CAREER & UK ROLES */}
        <div className="about-timeline-item">
          <div className="about-timeline-marker"></div>
          <div className="about-timeline-content">
            <div className="about-timeline-year">
              <span>2003 – 2014</span>
            </div>
            <h3 className="about-timeline-title">
              Engineer & Consultant (UK & India)
            </h3>
            <ul>
              <li>
                <b>Jagex Ltd., UK</b> – Delivered global billing/payment modules
                (Java, Spring MVC, MongoDB), 100k+ events/hr
              </li>
              <li>
                <b>IP Access Ltd., UK</b> – Built network orchestration modules,
                integrated message layers (Java, OSGi, JMS)
              </li>
              <li>
                <b>Citibank NA, UK</b> – FX trading, spot rates integration
                (Java, Tibco RV, SQL, Spring)
              </li>
              <li>
                <b>Persistent Systems, Infosys</b> – Projects in genomics,
                telecom, and production support; managed on-site and remote
                teams
              </li>
            </ul>
          </div>
        </div>
        {/* EDUCATION & SIDE FACTS */}
        <div className="about-timeline-item">
          <div className="about-timeline-marker"></div>
          <div className="about-timeline-content">
            <div className="about-timeline-year">
              <span>Degrees & Beyond</span>
            </div>
            <h3 className="about-timeline-title">Academics & Interests</h3>
            <ul>
              <li>
                M.Sc. Informatics (7.80 CGPA) & B.Sc. Electronics (Univ. of
                Delhi)
              </li>
              <li>
                Strong foundation in system design, computer science, and
                engineering
              </li>
              <li>Hobbies: Yoga, Badminton, Swimming, Trekking, Photography</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
